import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Grid, GridColumn as Column, GridCell, GridNoRecords, GridSortChangeEvent } from '@progress/kendo-react-grid';
import { SortDescriptor, orderBy } from '@progress/kendo-data-query';
import { fetchApi } from '../../services/api';
import LoadingPanel from '../LoadingPanel';
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{}>;

type State = {
    sort: SortDescriptor[];
    children: Child[];
    isLoading: boolean;
}

export interface Child {
    ChildID: number;
    ChildName: string;
    FacilityID: number;
    FacilityName: string;
    AccountID: number;
    AccountName: string;
}

class ChildNameCell extends GridCell {
    render() {
        return (
            <td>
                <Link style={{ color: '#007bff' }} to={`/child/${this.props.dataItem.ChildID}`}>
                    {this.props.dataItem.ChildName}
                </Link>
            </td>
        );
    }
}

class FacilityNameCell extends GridCell {
    render() {
        return (
            <td>
                <Link style={{ color: '#007bff' }} to={`/facility/${this.props.dataItem.FacilityID}`}>
                    {this.props.dataItem.FacilityName}
                </Link>
            </td>
        );
    }
}

class AccountNameCell extends GridCell {
    render() {
        return (
            <td>
                <Link style={{ color: '#007bff' }} to={`/accounts/${this.props.dataItem.AccountID}`}>
                    {this.props.dataItem.AccountName}
                </Link>
            </td>
        );
    }
}

class Children extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            children: [],
            isLoading: false,
            sort: [{field: "ChildName", dir: "asc"}],
        };

        this.getChildren = this.getChildren.bind(this)
        this.sortChange = this.sortChange.bind(this);
    }

    public componentWillMount() {
        // This method runs when the component is first added to the page
        this.getChildren();
    }

    public render() {
        return <React.Fragment>
            <DocumentTitle title="Children" />
            <h1>Children</h1>
            {this.state.isLoading && <LoadingPanel />}
            <Grid data={this.state.children}
                sortable={{
                    allowUnsort: true
                }}
                sort={this.state.sort}
                onSortChange={this.sortChange}
                pageable={{
                    buttonCount: 0,
                    info: true,
                    type: 'numeric',
                    pageSizes: false,
                    previousNext: false
                }}
                skip={0}
                take={this.state.children.length}
                total={this.state.children.length}>
                <GridNoRecords>
                    No children found, you can register new children in <Link style={{ color: '#007bff' }} to='/accounts'>Accounts</Link>.
                </GridNoRecords>
                <Column field="ChildName" title="Name" cell={ChildNameCell} />
                <Column field="AccountName" title="Account" cell={AccountNameCell} />
                <Column field="FacilityName" title="Facility" cell={FacilityNameCell} />
            </Grid>
            <br />
        </React.Fragment>;
    }

    private sortChange(event: GridSortChangeEvent) {
        this.setState({
            sort: event.sort,
            children: orderBy(this.state.children, event.sort)
        });
    }

    private getChildren() {
        const data = {
            FacilityID: localStorage.getItem("FACILITY_ID")
        }
        this.setState({ isLoading: true });
        fetchApi('api/Children/List', data, 'POST')
            .then((children: Child[]) => {
                this.setState({ children: orderBy(children, this.state.sort), isLoading: false });
            });
    }
}

export default Children;
